import styled from 'styled-components';
import { GhostSuccessButton } from 'ui/button';
import { FormField } from 'ui/formField';
import { colors, spacing, fontWeights, Subtitle2 } from 'ui/theme';

export const OAuthGroupGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: ${spacing.plusHalf};
  align-items: start;
  margin-bottom: ${spacing.base};
  && > div {
    margin-top: 0;
  }
`;

export const UnspacedSubtitle2 = styled(Subtitle2)`
  margin-top: ${spacing.plusHalf};
`;

export const CustomHeadersWrapper = styled(FormField)`
  margin-top: ${spacing.plusHalf};
`;

export const LightText = styled.span`
  color: ${colors.textSecondary};
  font-weight: ${fontWeights.regular};
`;

export const SpacedGhostSuccessButton = styled(GhostSuccessButton)`
  margin-top: ${spacing.half};
  & > *:first-child {
    margin-right: ${spacing.half};
  }
`;
